import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgent text-white py-3 px-4 shadow-md" data-id="element-109">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center text-center md:space-x-4 text-sm md:text-base font-medium" data-id="element-110">
        <p data-id="element-111">
          <span className="font-bold" data-id="element-112">¡OFERTA DE LANZAMIENTO!</span> 70% OFF
        </p>
        <div className="flex items-center mt-2 md:mt-0 bg-black/20 px-3 py-1 rounded-full" data-id="element-113">
          <div className="flex items-center space-x-1 font-mono font-bold tracking-wider" data-id="element-114">
            <span data-id="element-115">{formatTime(timeLeft.hours)}</span>
            <span data-id="element-116">:</span>
            <span data-id="element-117">{formatTime(timeLeft.minutes)}</span>
            <span data-id="element-118">:</span>
            <span data-id="element-119">{formatTime(timeLeft.seconds)}</span>
          </div>
        </div>
      </div>
    </div>;
}